import React from 'react';
import {reduxForm} from 'redux-form';
import FormField from '../form/form-field';
import ImageField from '../form/image-field';
import TextField from '../form/text-field';
import BaseForm from '../form/base-form';
import Button from '../button';
import {validateRequiredFields} from '../../utils/form';
import LocalizedStrings from '../../localization/strings';
import DateField from '../form/date-field';
import Alert from '../alert';


const fields = ['id', 'title', 'body', 'imageId', 'publish_date'];


function validate(values) {
    let errors = {
        _error: null
    };
    errors = validateRequiredFields(values, [
        'title', 'body', 'imageId', 'publish_date'
    ], errors);
    return errors;
}

class PostForm extends BaseForm {

    render() {
        const {
            submitting,
            error,
            handleSubmit,
            fields: {
                title,
                body,
                imageId,
                publish_date
            }
        } = this.props;
        return (
            <div>
                <form onSubmit={handleSubmit(this.submit.bind(this))}>
                    {error && <Alert type="error">{error}</Alert>}

                    <FormField label={LocalizedStrings.title} name="title" field={title}>
                        <input ref="title" className="border-full larger" placeholder={LocalizedStrings.title} type="text" {...title}/>
                    </FormField>
                    <FormField label={LocalizedStrings.image} name="featured-image" field={imageId}>
                        <ImageField {...imageId}></ImageField>
                    </FormField>

                    <FormField label={LocalizedStrings.publishDate} name="body" field={publish_date}>
                        <DateField {...publish_date} timeFormat={false}></DateField>
                    </FormField>

                    <FormField label={LocalizedStrings.body} name="body" field={body}>
                        <TextField {...body}></TextField>
                    </FormField>

                    <div className="actions-row">

                        <Button loading={submitting} submit={true} disabled={submitting} type="primary">
                            {LocalizedStrings.submit}
                        </Button>

                    </div>

                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'post-form',
    fields,
    validate,
    destroyOnUnmount: true
}, state => ({initialValues: state.post.post.item}))(PostForm);



// WEBPACK FOOTER //
// ./src/js/components/post/post-form.js